<template>
  <div v-if="data.registro"
       class="termo">
    <div id="botoes_edicao"
         :class="{
           'bt-scroll-top': resize.value < 190,
           'bt-scroll-float': resize.value > 190,
           'bt-scroll-bottom': resize.value > 1350
         }">
      <div v-b-tooltip.hover.left="'Imprimir'"
           class="mt-2">
        <b-button class="Termo--btn-info"
                  style="padding: 6px 5.5px;"
                  @click="imprimir">
          <icon-svg class="icon--xxs icons--white"
                    style="height: 1.3rem;width: 1.3rem;"
                    icon="print" />
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Aumentar zoom'"
           class="mt-1">
        <b-button class="Termo--btn-info"
                  style="padding: 6px 5.5px;"
                  :disabled="zoom > 1"
                  @click="zoomPlus()">
          <icon-svg class="icon--xxs icons--white"
                    style="height: 1.3rem;width: 1.3rem;"
                    icon="zoomPlus" />
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Menos zoom'"
           class="mt-1">
        <b-button class="Termo--btn-info"
                  style="padding: 6px 5.5px;"
                  :disabled="zoom < 1"
                  @click="zoomMinus()">
          <icon-svg class="icon--xxs icons--white"
                    style="height: 1.3rem;width: 1.3rem;"
                    icon="zoomMinus" />
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Voltar ação'"
           class="mt-1">
        <b-button class="Termo--btn-no-select"
                  @click="exec($event,'undo')">
          <span>&lt;</span>
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Próxima ação'"
           class="mt-1">
        <b-button class="Termo--btn-no-select"
                  @click="exec($event,'redo')">
          &gt;
        </b-button>
      </div>

      <div v-if="edit"
           v-b-tooltip.hover.left="'Negrito'"
           class="mt-1">
        <b-button class="Termo--btn-no-select"
                  :class="{ 'Termo--btn-selected': state.bold }"
                  @click="exec($event,'bold')">
          <b>B</b>
        </b-button>
      </div>

      <div v-if="edit"
           v-b-tooltip.hover.left="'Itálico'"
           class="mt-1">
        <b-button class="Termo--btn-no-select"
                  :class="{ 'Termo--btn-selected': state.italic }"
                  @click="exec($event,'italic')">
          <i>It</i>
        </b-button>
      </div>

      <div v-if="edit"
           v-b-tooltip.hover.left="'Sublinhado'"
           class="mt-1">
        <b-button class="Termo--btn-no-select"
                  :class="{ 'Termo--btn-selected': state.underline }"
                  @click="exec($event,'underline')">
          <u>U</u>
        </b-button>
      </div>
    </div>

    <div class="row">
      <div class="col body">
        <div class="pagina"
             :class="{ 'pagina-zoom-2': zoom == 2, 'pagina-zoom-1': zoom == 1 }"
             @click="getState"
             @keyup="getState">

          <div v-if="!isCertidaoEletronica"
               v-html="html" />

          <div v-else
               class="pagina"
               v-html="html" />
        </div>
      </div>
    </div>

    <hr>

    <div id="assinatura_certidao">
      <sub-header-grey class="row mt-1 mb-1">
        <div class="d-flex justify-content-between pb-1 pl-2">
          Assinatura de Termo
        </div>
      </sub-header-grey>

      <b-row>
        <div class="col-5">
          <label class="impressao--label">
            Assinante do termo:
          </label>
          <b-form-select v-model="impressao.assinante"
                         v-validate="'required'"
                         class="mb-3"
                         :class="{ 'is-invalid': errors.has('assinante') }"
                         name="assinante"
                         size="sm"
                         @change="changeImpressao(impressao)">
            <template v-slot:first>
              <option :value="null" disabled>
                -- Selecione uma opção --
              </option>
            </template>
            <option v-for="(assinante, index) in assinantes"
                    :key="'assinante_' + index"
                    :value="assinante">
              {{ assinante.nome }}
            </option>
          </b-form-select>
        </div>
      </b-row>
    </div>

    <div class="text-right">
      <button class="mr-2 btn btn-sm btn-default"
              @click="changeOrdemServico">
        Voltar
      </button>

      <b-dropdown size="sm"
                  right
                  split
                  text="Pré Visualizar"
                  @click="visualizar()">
        <b-dropdown-item @click="visualizar()">
          Pré Visualizar
        </b-dropdown-item>

        <b-dropdown-item v-if="selectMinuta === 'certidao_eletronica'"
                         @click="imprimir()">
          Baixar arquivo
        </b-dropdown-item>
        <b-dropdown-item v-if="selectMinuta === 'certidao_eletronica'"
                         @click="$emit('onGerarCertidao')">
          Gerar Certidão Eletrônica
        </b-dropdown-item>
        <b-dropdown-item v-else
                         @click="imprimir()">
          Imprimir
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
import print from '@/assets/icons/print.svg?sprite'
import { mapGetters } from 'vuex'

export default {
  name: "TermoTela",
  components: { SubHeaderGrey },
  props: ["data", "impressao", "tipo", "html", "assinantes", "zoom", "selectMinuta"],
  data () {
    return {
      termo: this.data,
      print,
      zoomLocal: 0,
      state: {
        undo: false,
        redo: false,
        bold: false,
        italic: false,
        underline: false
      },
      edit: false
    }
  },
  computed: {
    ...mapGetters({
      resize: 'window/getScroll',
    }),
    isCertidaoEletronica () {
      return this.tipo === 'habilitacao' &&
             this.selectMinuta === 'certidao_eletronica'
    }
  },
  methods: {
    visualizar () {
      const el = this.isCertidaoEletronica
        ? document.querySelector('.pagina')
        : document.querySelector('#paste-html') || document.querySelector('.termo')

      if (!el) return

      const htmlStr = el.innerHTML
        .replace(/contenteditable/g, ' ')
        .replace(/termo__/g, 'modal_termo__')

      this.$emit('onVisualizar', htmlStr)
    },

    imprimir () {
      const el = this.isCertidaoEletronica
        ? document.querySelector('.pagina')
        : document.querySelector('#paste-html') || document.querySelector('.termo')

      if (!el) return

      const htmlStr = el.innerHTML
        .replace(/contenteditable/g, ' ')
        .replace(/termo__/g, 'modal_termo__')

      this.$emit('onImprimir', htmlStr)
    },

    exec (event, command, value = null) {
      document.execCommand(command, false, value)
      this.state = {
        undo: this.statusExec('undo'),
        redo: this.statusExec('redo'),
        bold: this.statusExec('bold'),
        italic: this.statusExec('italic'),
        underline: this.statusExec('underline')
      }
    },

    statusExec (command) {
      return document.queryCommandState(command)
    },

    getState (event) {
      this.edit =
        event.target.contentEditable === "true" ||
        event.target.parentElement?.contentEditable === "true" ||
        event.target.parentElement?.parentElement?.contentEditable === "true"

      this.state = {
        undo: this.statusExec('undo'),
        redo: this.statusExec('redo'),
        bold: this.statusExec('bold'),
        italic: this.statusExec('italic'),
        underline: this.statusExec('underline')
      }
    },

    changeOrdemServico () {
      this.$emit('onChangeOrdemServico')
    },
    zoomPlus () {
      this.$emit('onZoom', 'plus')
    },
    zoomMinus () {
      this.$emit('onZoom', 'minus')
    },
    changeImpressao (impressao) {
      this.$emit('changeImpressao', impressao)
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../../scss/_components/termos";
</style>
